module.exports = __webpack_public_path__ + "img/about-4.79a5150c.webp";